import { render, staticRenderFns } from "./email-template-front.vue?vue&type=template&id=07a22112&scoped=true&"
import script from "./email-template-front.vue?vue&type=script&lang=js&"
export * from "./email-template-front.vue?vue&type=script&lang=js&"
import style0 from "./email-template-front.vue?vue&type=style&index=0&id=07a22112&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a22112",
  null
  
)

export default component.exports